/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
// import {useLocation} from "react-router";
import { NavLink, useLocation }  from "react-router-dom";
import SVG from "react-inlinesvg";
import {checkIsActive, toAbsoluteUrl} from "../../../../_helpers";

export function AdminAsideMenuList({layoutProps}) {
    const location = useLocation();
    const getMenuItemActive = (url, hasSubmenu = false) => {
        return checkIsActive(location, url)
            ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
            : "";
    };

    return (
        <>
            {/* begin::Menu Nav */}
            <ul className={`menu-nav ${layoutProps.ulClasses}`}>
                <li
                    className={`menu-item ${getMenuItemActive("/admin/dashboard", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/admin/dashboard">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Design/Layers.svg")}/>
                        </span>
                        <span className="menu-text">میز کار</span>
                    </NavLink>
                </li>

                <li
                    className={`menu-item ${getMenuItemActive("/admin/orders", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/admin/orders">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Cart1.svg")}/>
                    </span>
                    <span className="menu-text">سفارشات</span>
                    </NavLink>
                </li>

                <li
                    className={`menu-item ${getMenuItemActive("/admin/baskets", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/admin/baskets">
                        <span className="svg-icon menu-icon">
                          <SVG src={toAbsoluteUrl("/media/svg/icons/Shopping/Bag1.svg")}/>
                        </span>
                        <span className="menu-text">سبد‌‌های خرید</span>
                    </NavLink>
                </li>

                <li
                    className={`menu-item ${getMenuItemActive("/admin/products", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/admin/products">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Clothes/Hanger.svg")}/>
                    </span>
                        <span className="menu-text">محصولات</span>
                    </NavLink>
                </li>


                <li
                    className={`menu-item ${getMenuItemActive("/admin/factors", false)}`}
                    aria-haspopup="true"
                >
                    <NavLink className="menu-link" to="/admin/factors">
                    <span className="svg-icon menu-icon">
                      <SVG src={toAbsoluteUrl("/media/svg/icons/Clothes/Hanger.svg")}/>
                    </span>
                        <span className="menu-text">فاکتور ها</span>
                    </NavLink>
                </li>


            </ul>

            {/* end::Menu Nav */}
        </>
    );
}
